export default "__VITE_ASSET__CNv_2AH1__"